var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 20,
  viewBox: "0 0 16 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 15.2381C9.1 15.2381 10 14.381 10 13.3333C10 12.2857 9.1 11.4286 8 11.4286C6.9 11.4286 6 12.2857 6 13.3333C6 14.381 6.9 15.2381 8 15.2381ZM14 6.66667H13V4.7619C13 2.13333 10.76 0 8 0C5.24 0 3 2.13333 3 4.7619V6.66667H2C0.9 6.66667 0 7.52381 0 8.57143V18.0952C0 19.1429 0.9 20 2 20H14C15.1 20 16 19.1429 16 18.0952V8.57143C16 7.52381 15.1 6.66667 14 6.66667ZM4.9 4.7619C4.9 3.13333 6.29 1.80952 8 1.80952C9.71 1.80952 11.1 3.13333 11.1 4.7619V6.66667H4.9V4.7619ZM14 18.0952H2V8.57143H14V18.0952Z",
  fill: "black",
  fillOpacity: 0.57
})));
export { SvgLock as ReactComponent };
export default __webpack_public_path__ + "assets/icons/lock.c3c412.svg";